import React, { useState, useContext, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./Context/AuthContext";
// layouts
import Layout from "./Layout/Layout";
//Page
import Dashboard from "./Pages/Dashboard/Dashboard";
import Page404 from "./Pages/LogIn/Page404";
import Setting from "./Pages/Setting/Setting";
import { User } from "./Pages/User/User";
import Report from "./Pages/Report/Report";
import Login from "./Pages/LogIn/Login";
import ForgotPassword from "./Pages/LogIn/ForgotPassword";
import VerifyOtp from "./Pages/LogIn/VerifyOtp";
import ResetPassword from "./Pages/LogIn/ResetPassword";
import Student from "./Pages/Student/Student"
import StudentDetail from "./Components/Students/StudentDetail/StudentDetail"
import Attendance from "./Pages/Attendance/Attendance"
import AttendenceCheck from "./Components/Attendances/AttendenceCheck"
import AcademicYear from "./Pages/AcademicYear/AcademicYear"
import School from "./Pages/School/School"
import Level from "./Pages/Level/Level"
import Group from "./Pages/Group/Group"
import Class from "./Pages/Class/Class"

export default function Router({ prefersDarkMode, setPrefersDarkMode }) {

  // ============================== Check Token ===============================
  const { state } = useContext(AuthContext);
  const [token, setToken] = useState(JSON.parse(window.localStorage.getItem("token")));
  const [verifyToken, setVerifyToken] = useState(
    JSON.parse(window.localStorage.getItem("verifyToken"))
  );

  useEffect(() => {
    let userToken = JSON.parse(window.localStorage.getItem("token"));
    let verifyToken = JSON.parse(window.localStorage.getItem("verifyToken"));
    if (userToken) {
      setToken(userToken);
      return;
    }
    if (verifyToken) {
      setVerifyToken(userToken);
      return;
    }
    if (state?.user?.token) {
      setTimeout(() => {
        setToken(state?.user?.token);
        window.localStorage.setItem("token", JSON.stringify(state?.user?.token));
      }, 1200);
    } else {
      setToken(null);
    }
  }, [state?.user, token]);

  // ============================== End Token =======================================

  const LoginPage = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "/verifyOtp", element: <VerifyOtp /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "*", element: <Login /> },
  ]);

  const Content = useRoutes([
    {
      path: "/",
      element: (
        <Layout
          to="/dashboard"
          prefersDarkMode={prefersDarkMode}
          setPrefersDarkMode={setPrefersDarkMode}
        />
      ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "dashboard", element: <Dashboard /> },

        { path: "student", element: <Student /> },
        { path: "/student/student-detail", element: <StudentDetail /> },

        { path: "attendance", element: <Attendance /> },
        { path: "/attendance/attendance-check", element: <AttendenceCheck /> },

        { path: "report", element: <Report /> },

        { path: "setting", element: <Setting /> },
        { path: "setting/user", element: <User /> },
        { path: "setting/academic-year", element: <AcademicYear /> },
        { path: "setting/school", element: <School /> },
        { path: "setting/level", element: <Level /> },
        { path: "setting/group", element: <Group /> },
        { path: "setting/class", element: <Class /> },



        { path: "*", element: <Page404 /> },
      ],
    },
  ]);

  // if (token !== undefined && token !== null) {
  //   return Content;
  // } else {
  //   return LoginPage;
  // }

  // when have verify token to update user pwd
  if (token !== undefined && token !== null) {
    return Content;
  } else if (verifyToken !== undefined && verifyToken !== null) {
    return LoginPage;
  } else {
    return LoginPage;
  }

}
